"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useController = void 0;
const react_1 = require("react");
const getKeyValueWithoutError = (obj, key) => {
    try {
        return obj[key];
    }
    catch (e) {
        return undefined;
    }
};
/**
 * Safely access and update a value in a parent object by its key.
 * */
const useController = (parentValue, key, onParentValueChange, isArrayIndex = false) => {
    const [value, setValue] = (0, react_1.useState)(getKeyValueWithoutError(parentValue, key));
    const onChange = (0, react_1.useCallback)((value) => {
        try {
            setValue(value);
            if (isArrayIndex) {
                const newArray = [...parentValue];
                newArray[key] = value;
                onParentValueChange(newArray);
            }
            else {
                onParentValueChange(Object.assign(Object.assign({}, parentValue), { [key]: value }));
            }
        }
        catch (e) {
            // Ignore.
        }
    }, [parentValue, key, onParentValueChange, isArrayIndex]);
    (0, react_1.useEffect)(() => {
        try {
            setValue(getKeyValueWithoutError(parentValue, key));
        }
        catch (e) {
            setValue(undefined);
        }
    }, [parentValue, key]);
    return [value, onChange];
};
exports.useController = useController;
